import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {BreadcrumbModule} from "primeng/breadcrumb";
import {MenubarModule} from "primeng/menubar";
import {MenuItem, MessageService} from "primeng/api";
import {NavbarGovCoComponent} from "../navbar-gov-co/navbar-gov-co.component";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {ButtonDirective} from "primeng/button";
import {FormsModule} from "@angular/forms";
import {InputTextModule} from "primeng/inputtext";
import {NgIf, NgOptimizedImage} from "@angular/common";
import {MenuModule} from "primeng/menu";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {NavigationEnd, Router} from "@angular/router";
import {filter, firstValueFrom, forkJoin, Subscription} from "rxjs";

@Component({
    selector: 'app-header-gov-co',
    standalone: true,
    imports: [
        BreadcrumbModule,
        MenubarModule,
        NavbarGovCoComponent,
        OverlayPanelModule,
        ButtonDirective,
        FormsModule,
        InputTextModule,
        NgOptimizedImage,
        MenuModule,
        TranslatePipe,
        NgIf
    ],
    templateUrl: './header-gov-co.component.html',
    styleUrl: './header-gov-co.component.scss'
})
export class HeaderGovCoComponent implements OnInit, OnDestroy {

    menuItems: MenuItem[] = [];
    nombreTramite: string = '';
    translations: any = {};
    hideSearch: boolean = false;
    private subscription: Subscription | undefined = undefined;


    private readonly router: Router = inject(Router);
    private readonly _ms: MessageService = inject(MessageService);
    private readonly _t: TranslateService = inject(TranslateService);

    ngOnInit() {
        this.initMenu();
        this.translate().then();
        this.routing();
    }

    ngOnDestroy(): void {
        if (this.subscription)
            this.subscription.unsubscribe();
    }


    private routing = () => {
        this.subscription = this.router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe({
                next: (event:any) => {
                    this.verifyRouting(event.url);
                }
            });
    }

    private verifyRouting = (url: string) => {
        this.hideSearch = (url === '/sede-electronica/consulta' ||
            url.startsWith('/sede-electronica/consulta/'));
        if (this.hideSearch) {
            this.nombreTramite = '';
        }
    }

    private async translate(): Promise<void> {
        this.translations = await firstValueFrom(forkJoin({
            infoSummary: this._t.get('form.msg.campo-requerido'),
            warnSummary: this._t.get('form.msg.warn-summary'),
        }));
    }

    private initMenu() {
        this.menuItems = [
          {
            tabindex: "0",
            label: 'Inicio',
            routerLink: '/sede-electronica/inicio',
            items: [
              {
                tabindex: "1",
                label: 'Consulta de Trámites',
                routerLink: '/sede-electronica/consulta',
              },
              {
                tabindex: "2",
                label: 'PQRSDF',
                routerLink: '/sede-electronica/pqrsd',
              },

            ]

          }, {
            tabindex: "3",
            label: 'Transparencia y acceso a la información pública',
            style: {'max-width': '16.14rem'},

          }, {
            tabindex: "4",
            label: 'Atención y servicios a toda la ciudadanía',
            style: {'max-width': '14.285rem'},
          },
          {
            tabindex: "5",
            label: 'Participa',
          }, {
            tabindex: "6",
            label: 'Estado de sus trámites',
            style: {'max-width': '10rem'},
          }, {
            tabindex: "7",
            label: 'Firma electrónica',
            style: {'max-width': '9.36rem'},
          }, {
            tabindex: "8",
            label: 'Preguntas Frecuentes',
            style: {'max-width': '9.36rem'},
          }
        ];
    }

    search = () => {
        if (!this.nombreTramite.trim()) {
            this._ms.add({
                severity: 'warn',
                summary: this.translations.warnSummary,
                detail: this.translations.infoSummary,
            });
            return;
        }
        this.router.navigate(['/sede-electronica', 'consulta', this.nombreTramite]).then();

    }


}
